export default defineNuxtPlugin(() => {
  // Only run on client side to avoid the composable error
  if (import.meta.server) return

  const dataStore = useDataAll()
  const { initializeTranslations } = useTranslations()

  let isInitializing = false

  const safeInitializeTranslations = async (data) => {
    if (isInitializing) {
      console.log('Translation initialization already in progress, skipping...')
      return
    }

    isInitializing = true
    try {
      console.log('Initializing translations from plugin...')
      await initializeTranslations(data)
      console.log('Translations initialized successfully from plugin')
    } catch (error) {
      console.error('Error initializing translations from plugin:', error)
    } finally {
      isInitializing = false
    }
  }

  // Check if data is already available and initialize
  nextTick(() => {
    if (dataStore.hasData && dataStore.data?.StaticText) {
      safeInitializeTranslations(dataStore.data)
    }
  })

  // Watch for data changes
  watch(
    () => dataStore.data,
    async (newData) => {
      if (newData?.StaticText && !isInitializing) {
        await safeInitializeTranslations(newData)
      }
    },
    { immediate: false }
  )

  // Provide a manual initialization method
  return {
    provide: {
      initTranslations: safeInitializeTranslations
    }
  }
})
